import { sendGoogleEvent, checkString, sendRequest } from '@html/_common/utils';

export default function AOSerpEmailSignup() {
  let $form = null;
  let $input = null;
  let $cta = null;
  let ctaSuccessText = '';
  let ctaErrorText = '';
  let version = null;
  const blockClass = 'ao-serp-email-signup';

  this.initiate = () => {
    $form = $(`.js-${blockClass}__form`);
    $form.submit(this.onSubmit);

    $input = $form.find(`.js-${blockClass}__input`);
    $cta = $form.find(`.js-${blockClass}__cta`);
    ctaSuccessText = $form.data('success-text');
    ctaErrorText = $form.data('error-text');
    version = $(`.js-${blockClass}`).data('version');

    $input.on('change', (event) => {
      $input.val($.trim(event.target.value));
    });
  };

  this.onSubmit = (event) => {
    event.preventDefault();
    const email = $.trim($input.val());
    if (!email || !checkString(email, 'email')) {
      alert(ctaErrorText); // eslint-disable-line no-alert
      return false;
    }

    sendRequest('/api/subscribe/check', { email, omnimove_action_id: 'performance_marketing_signup' }, (data) => {
      if (data.status === 'OK') {
        if (version !== 3) this.onSuccess();
        else this.onSuccessV3();
      } else {
        $form.find('.scout-element__input--error').removeClass('hid');
      }
    });

    return false;
  };

  this.onSuccessV3 = () => {
    const $successMessage = $(`.${blockClass}-v${version}__success-message`);
    const $container = $(`.${blockClass}-v${version}__container`);

    $successMessage.css('display', 'inline-block');
    $container.hide();

    sendGoogleEvent('Simple Form', 'Submit', 'V3', { ampEventName: 'newsletter_subscribed' });
  };

  this.onSuccess = () => {
    const $successText = $(`.${blockClass}-v${version}__success-text`);
    $cta.attr('disabled', true);

    setTimeout(() => {
      $successText.text(ctaSuccessText);
      $successText.show();
    }, 250);

    setTimeout(() => {
      $successText.hide();
      $cta.removeAttr('disabled');
    }, 2000);

    sendGoogleEvent('Simple Form', 'Submit', `V${version}`, { ampEventName: 'newsletter_subscribed' });
  };
}
